import { RootState } from '../redux/store';

/**
 * Returns the entire designer state slice
 */
export const getDesignerSlice = (state: RootState) => state.designer;
